import React, { useState } from 'react';
import { Grid, GridColumn, Container, Header, Popup, Icon } from 'semantic-ui-react';
import BudgetVsSizeChart from './BudgetVsSizeChart';
import DealFunnelChart from './DealFunnelChart';
import MedianIrrTrendChart from './MedianIrrTrendChart';
import DaysMatchToFirstBidChart from './DaysMatchToFirstBidChart';
import InvestorInviteToBidRatioChart from './InvestorInviteToBidRatioChart';
import RecentLoginsPanel from './RecentLoginsPanel';
import DateRangeFilter from './DateRangeFilter';
import StateFilter from './StateFilter';
import DownloadKpis from '~/features/projectSearch/DownloadKpis';
import DownloadHubspot from './DownloadHubspot';
import DownloadBuyerProfiles from './DownloadBuyerProfiles';
import UploadBuyerProfiles from './UploadBuyerProfiles';
import BuyerProfileImportChanges from './BuyerProfileImportChanges';
import '../styles.scss';
import './styles.scss';

const AdminDashboard: React.FC = () => {
  const [interval, setIntervalState] = useState<string>('6');
  const [states, setStates] = useState<string[]>([]);
  // Bumped on each import start/completion so the history list refetches.
  const [importRefresh, setImportRefresh] = useState(0);

  return (
    <div id="admin-dashboard" className="dashboard">
      <Container>
        <Grid stackable>
          <GridColumn width={12}>
            <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexWrap: 'wrap', gap: '0.5rem' }}>
              <Header as="h1" style={{ marginBottom: '8px', display: 'inline-block', width: '100%' }}>Reports</Header>
              <div className='card' style={{ width: '100%', marginBottom: '4px' }}>
                <h3>KPI export
                  <Popup
                    position="top center"
                    hoverable
                    inverted
                    trigger={<Icon name="info circle" color="blue" style={{ marginLeft: '0.5rem', cursor: 'pointer', marginTop: '-4px' }} />}
                    content={(
                      <div>
                        <div style={{ fontWeight: 600, marginBottom: '0.5rem' }}>A project is &quot;active&quot; in the selected quarter if it:</div>
                        <ul style={{ margin: 0, paddingLeft: '1rem' }}>
                          <li>Was submitted in the quarter</li>
                          <li>Was matched to one or more new investors in the quarter</li>
                          <li>Received a bid in the quarter</li>
                          <li>Was in bidding status at any point in the quarter</li>
                          <li>Was in diligence status at any point in the quarter</li>
                        </ul>
                      </div>
                    )}
                  />
                  </h3>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', width: '100%' }}>
                  <DownloadKpis />
                </div>
              </div>
              <div className='card' style={{ width: '100%', marginBottom: '4px' }}>
                <h3>HubSpot export</h3>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', width: '100%' }}>
                  <DownloadHubspot />
                </div>
              </div>
              <div className='card' style={{ width: '100%', marginBottom: '4px' }}>
                <h3>Buyer profiles</h3>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', width: '100%' }}>
                  <DownloadBuyerProfiles />
                  <UploadBuyerProfiles onImported={() => setImportRefresh((n) => n + 1)} />
                </div>
                <BuyerProfileImportChanges refreshKey={importRefresh} />
              </div>
              <div className='card' style={{ width: '100%', marginBottom: '-20px' }}>
                <h3>Dashboard filters</h3>
                <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: '1rem', width: '100%' }}>
                  <StateFilter value={states} onChange={setStates} />
                  <DateRangeFilter value={interval} onChange={setIntervalState} />
                </div>
              </div>
            </div>
          </GridColumn>
          <GridColumn computer={8} tablet={12} mobile={16}>
            <MedianIrrTrendChart interval={interval} onIntervalChange={setIntervalState} states={states} />
            <BudgetVsSizeChart interval={interval} onIntervalChange={setIntervalState} states={states} />
            <DaysMatchToFirstBidChart interval={interval} onIntervalChange={setIntervalState} states={states} />
            <RecentLoginsPanel />
          </GridColumn>
          <GridColumn computer={4} tablet={12} mobile={16}>
            <DealFunnelChart interval={interval} onIntervalChange={setIntervalState} states={states} />
            <InvestorInviteToBidRatioChart interval={interval} onIntervalChange={setIntervalState} states={states} />
          </GridColumn>
        </Grid>
      </Container>
    </div>
  );
};

export default AdminDashboard;